export default __webpack_public_path__ + "static/media/joe.641da105.svg";